import { render, staticRenderFns } from "./local-service-card.vue?vue&type=template&id=09932eda&scoped=true"
import script from "./local-service-card.vue?vue&type=script&lang=js"
export * from "./local-service-card.vue?vue&type=script&lang=js"
import style0 from "./local-service-card.vue?vue&type=style&index=0&id=09932eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09932eda",
  null
  
)

export default component.exports